import {
  Typography,
  TYPOGRAPHY_WEIGHT
} from '../../../../components/Typography'
import Chart from './Chart'
import { TGroupedLinearChart } from '../../../../pages/Compliance/types'
import InfiniteList from '../../../../components/InfiniteList/InfiniteList'
import { useComplianceContext } from '../../../../pages/Compliance/Providers/ComplianceContextProvider'
import { useMemo } from 'react'
import { LoadingOutlined } from '@ant-design/icons'

const SpendByCategory = () => {
  const { state } = useComplianceContext()
  const { spendByCategory, loadMoreSpendByCategory } = state
  const Loader = useMemo(
    () => <LoadingOutlined className="chat-list-feature-list__spinner" spin />,
    []
  )

  return (
    <div
      className="compliance-container__chart-wrapper  spend-by-category part charts_ongoing-contracts_container"
      data-testid="spendByCategoryContainer"
    >
      <Typography.Body1
        className="compliance-container__chart-wrapper__title"
        weight={TYPOGRAPHY_WEIGHT.BOLD}
      >
        Spend by Category
      </Typography.Body1>
      <InfiniteList<TGroupedLinearChart>
        items={spendByCategory}
        loader={Loader}
        renderItem={Chart}
        loading={false}
        keyExtractor={(item) => item.category}
        hasNextPage={loadMoreSpendByCategory.hasNextPage}
        onLoadMore={loadMoreSpendByCategory.handleLoadMore}
        listEmptyComponent={
          <div className="full-width full-height row align-center justify-center empty-state">
            <Typography.Body1>The list is empty</Typography.Body1>
          </div>
        }
        className="chat-list-feature-list"
      />
    </div>
  )
}

export default SpendByCategory
